/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
export const NOTIFICATIONS_UPDATE = 'NOTIFICATIONS_UPDATE';
